//* 상주만 보는 Router hased by MemberId

import { FC, Suspense, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import CourtesyAccessGate from '@service/bugo/components/CourtesyAccessGate';
import MemberObituaryPage from '@service/bugo/page/MemberObituaryPage';
import { useBugoByMemberIdHook } from '@shared/api/bugo/bugo.hook';
import { bugoByMemberIdStateSelectorFamily } from '@shared/api/bugo/bugo.selector';
import { RouteFallback } from '@shared/components/RouteFallback';
import { lazyWithReload } from '@shared/utils/lazyWithReload';
import _ from 'lodash';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

//* 답례글 화면 3개는 한 청크("courtesy")로 — 미리보기 캡처(html2canvas) 등이 무거워 상주 부고장 기본 번들에서 뺀다
const CourtesySenderPage = lazyWithReload(
  () =>
    import(/* webpackChunkName: "courtesy" */ '@service/bugo/page/CourtesySenderPage'),
);
const CourtesySenderPreviewPage = lazyWithReload(
  () =>
    import(
      /* webpackChunkName: "courtesy" */ '@service/bugo/page/CourtesySenderPreviewPage'
    ),
);
const CourtesyEditPage = lazyWithReload(
  () => import(/* webpackChunkName: "courtesy" */ '@service/bugo/page/CourtesyEditPage'),
);

const BugoMemberIdRouter: FC = () => {
  const { memberId } = useParams();
  // 게이트가 같은 키의 atom을 읽어야 하므로 조회 키를 한 곳에서 만든다.
  const memberId_ = memberId ?? 'undefined';
  useBugoByMemberIdHook(memberId_);
  const bugoByMemberIdState = useRecoilValue(
    bugoByMemberIdStateSelectorFamily(memberId_),
  );

  const bugoTheme = useMemo(() => {
    if (bugoByMemberIdState.status === 'success' && bugoByMemberIdState.data) {
      const bugo = bugoByMemberIdState.data;
      const index = bugo.fevent.bugoBrandAgencyIndex;
      return !_.isNil(index) && bugo.bugoBrand?.bugoAgencyList
        ? bugo.bugoBrand.bugoAgencyList[index]?.theme
        : bugoByMemberIdState.data?.bugoBrand?.bugoAgency?.theme;
    }
  }, [bugoByMemberIdState.data, bugoByMemberIdState.status]);

  return (
    <div className={`max-w-inherit ${bugoTheme}`}>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          //* 부고 공유 페이지(개인정보동의, 등록도 할 수 있음)
          <Route path="bugo" element={<MemberObituaryPage />} />
          //* 답례글 공유 페이지 (부고 없음 / 발인 후 60일 초과 시 안내 화면으로 대체)
          <Route path="courtesy" element={<CourtesyAccessGate memberId={memberId_} />}>
            <Route path="" element={<CourtesySenderPage />} />
            <Route path="preview" element={<CourtesySenderPreviewPage />} />

            <Route path="edit" element={<CourtesyEditPage />} />
          </Route>
          <Route path="*" element={<Navigate to="bugo"></Navigate>} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default BugoMemberIdRouter;
